module.exports = __webpack_public_path__ + "static/img/twjd-sdr3.831eb50.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdr3.png
// module id = 868
// module chunks = 0